import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		timeContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
		},
		leftContent: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',

			[theme.breakpoints.down('sm')]: {
				alignItems: 'center',
			},
		},
		title: {
			marginBottom: theme.spacing(2),

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileContentAlignment?.metaValue,
			},
		},
		text: {
			marginBottom: theme.spacing(4.87),
			width: '100%',
			maxWidth: theme.spacing(61.5),

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileContentAlignment?.metaValue,
			},
		},

		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'center',

			[theme.breakpoints.down('sm')]: {
				justifyContent: ({ metaData }) => metaData.mobileContentAlignment?.contentAlignment(),
			},
		},

		button: {
			width: 'auto',
			marginBottom: theme.spacing(1.5),

			[theme.breakpoints.down('sm')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},

			'&:disabled': {
				pointerEvents: ({ isBuilderMode }) => (isBuilderMode ? 'all' : null),
			},
		},
		list: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			marginBottom: theme.spacing(2),

			[theme.breakpoints.up('md')]: {
				justifyContent: 'flex-start',
			},
		},
	}),
	{ name: 'CallToAction-Cta18' },
)

export default useStyles
